import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { EditVarianceType } from '@webapp/platform/iam/entities/enums/EditVarianceTypeEnum'
import {
  type UserPurchasePriceLimitConstructor,
  UserPurchasePriceLimit,
} from '@webapp/platform/iam/entities/UserPurchasePriceLimit/UserPurchasePriceLimit'

export const UserPurchasePriceLimitConstructorFactory =
  Factory.Sync.makeFactory<UserPurchasePriceLimitConstructor>({
    id: Factory.each(() => faker.random.number()),
    dateModified: Factory.each(() => faker.date.past().toISOString()),
    editVarianceType: Factory.each(() =>
      faker.random.arrayElement(Object.values(EditVarianceType))
    ),
    restrictEditableVariance: Factory.each(() => faker.random.boolean()),
    varianceThresholdLimit: Factory.each(() =>
      faker.random.number().toString()
    ),
  })

export const UserPurchasePriceLimitFactory = EntityFactory(
  UserPurchasePriceLimit,
  UserPurchasePriceLimitConstructorFactory
)
